<app-toolbar></app-toolbar>

<div class="layout">
  <router-outlet></router-outlet>
</div>
